import { Page as T, Links } from '../Interfaces';

export class Page implements T {
    total: number = 0;
    count: number = 0;
    per_page: number = 0;
    current_page: number = 0;
    total_pages: number = 0;
    links: Links;
    constructor(json?: T) {
        if (json) Object.assign(this, json);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/page.ts